import React from 'react';
import { makeStyles } from '@material-ui/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import classnames from 'classnames';

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  },
  fadeOutFull: {
    background: '#FFFFFF'
  }
});

export default function CircularIndeterminate(props) {
  const classes = useStyles();
  const { fadeOutFull } = props;
  return (
    <div
      className={classnames(classes.root, {
        [classes.fadeOutFull]: fadeOutFull
      })}
    >
      <CircularProgress />
    </div>
  );
}
